<template>
    <div class="box">
        <div class="box-top">
            <img class="cover" :src="bookInfo.bookCover" alt="">
            <div class="right">
                <div class="name">
                    {{bookInfo.bookName}}
                </div>
                <div class="desc">
                    点击页码跳转到对应页答案
                </div>
            </div>
        </div>
        <div class="box-list">
            <div
                class="box-list_item"
                v-for="item in bookData"
                :key="item.pageId"
                @click="gotoPage(item)"
            >
                {{item.pageName}}
            </div>
        </div>
    </div>
</template>

<script lang="js">
import {Options, Vue} from 'vue-class-component';
import {answerPageList} from '@/api/api';

@Options({
    components: {
    },
    created() {
        const {type, level, id} = this.$route.query;
        this.answerPageList();
    }
})
export default class AnswerList extends Vue {
    bookInfo = {};
    bookData = [];

    async answerPageList() {
        const {type, level, id} = this.$route.query;
        const res = await answerPageList({
            bookParam: id,
            type,
            level
        });
        if (res.code === '0') {
            const {bookInfo, list} = res.data;
            this.bookInfo = bookInfo;
            this.bookData = list;
        }
        else {
            this.$toast(res.msg);
        }
    }

    gotoPage(item) {
        this.$router.push({
            path: '/daanPage',
            query: {
                pageId: item.pageId,
                pageName: item.pageName,
                ...this.$route.query
            }
        });
    }
}
</script>

<style lang="scss" scoped>
.box {
    width: 100vw;
    min-height: 100vh;
    padding: .64rem 0 0;
    box-sizing: border-box;

    &-top {
        display: flex;
        align-items: center;
        margin: 0 .43rem 0 .51rem;

        .cover {
            width: 2.67rem;
            height: 2.67rem;
            border-radius: .43rem;
            margin-right: .43rem;
        }

        .right {
            width: 65%;

            .name {
                font-weight: 600;
                font-size: .51rem;
                color: #0B0B0B;
                text-align: justify;
                font-style: normal;
            }

            .desc {
                margin-top: .11rem;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: .37rem;
                color: #6A6A6A;
            }
        }
    }

    &-list {
        padding-bottom: 1rem;
        margin-top: .53rem;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        margin-right: .256rem;
        margin-left: .256rem;

        &_item {
            width: calc((100% / 3) - .53rem);
            margin: 0 .265rem;
            margin-bottom: .43rem;
            // width: 2.67rem;
            height: .85rem;
            box-sizing: border-box;
            border-radius: .21rem;
            border: .01rem solid #AEAEAE;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: .37rem;
            color: #0B0B0B;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
}
</style>
